<div class="embeded-wrapper">
  <!-- embeded do youtube mandou eu fazer assim -->
  <iframe
    [src]="sanitizedPath()"
    frameborder="0"
    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
    allowfullscreen
  ></iframe>
</div>
